import { Skeleton } from "@/components/ui/skeleton";
import { useT } from "../shell/i18n";
import { useModuleNav } from "./module-nav";
import { Page } from "./page";

/**
 * A code download cannot know a page's data layout yet. Reuse its real navigation and
 * Page frame, not a second hand-maintained table/profile/calendar mockup. Once the module
 * arrives, its own tables and fact declarations supply the shaped data placeholders.
 */
export function RouteLoading() {
  const t = useT();
  const { section, module } = useModuleNav();
  const label = section?.label ?? module?.label;
  return (
    <Page title={label ? t(label) : t("notify.loading")}>
      <div role="status" className="flex flex-col gap-3 text-shell-caption text-muted-foreground">
        <span>{t("notify.loading")}</span>
        <Skeleton aria-hidden="true" className="h-1 w-full" />
      </div>
    </Page>
  );
}
